var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return _vm._l((_vm.items),function(item,i){return _c('text-grid-row',{key:i,attrs:{"width":_vm.width}},_vm._l((_vm.items[i]),function(item2,j){return _c('text-grid-column',{key:j},[_vm._v(" "+_vm._s(item2)+" ")])}),1)})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }